/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'addPer': {
    width: 16,
    height: 16,
    viewBox: '0 0 20 20',
    data: '<path pid="0" class="st0" d="M12.5 12.5V10h1.9c1-1.1 1.6-2.5 1.6-4 0-3.3-2.7-6-6-6S4 2.7 4 6c0 1.9.9 3.7 2.4 4.8C3.2 12.2 1 15.3 1 19h2c0-3.9 3.1-7 7-7 .9 0 1.7.2 2.5.5zM6 6c0-2.2 1.8-4 4-4s4 1.8 4 4-1.8 4-4 4-4-1.8-4-4z"/><path pid="1" class="st0" d="M15.5 14.5V11h-2v3.5H10v2h3.5V20h2v-3.5H19v-2z"/>'
  }
})



// WEBPACK FOOTER //
// ./src/views/icons/addPer.js